import { Component, type ErrorInfo, type ReactNode } from "react";
export class AppErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null };
  static getDerivedStateFromError(error: Error) {
    return { error };
  }
  componentDidCatch(error: Error, info: ErrorInfo) {
    dispatchEvent(
      new CustomEvent("academy:frontend-error", {
        detail: { message: error.message, stack: info.componentStack },
      }),
    );
  }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <main
        role="alert"
        style={{
          minHeight: "100vh",
          display: "grid",
          placeItems: "center",
          padding: 24,
          background: "#060716",
          color: "#f7f8ff",
          font: "16px/1.5 Inter,system-ui,sans-serif",
        }}
      >
        <section>
          <p style={{ color: "#22d3ee", fontWeight: 800 }}>WORKSPACE_ERROR</p>
          <h1>This workspace could not continue.</h1>
          <p>Reload the workspace to try again.</p>
          <button type="button" onClick={() => location.reload()}>
            Reload workspace
          </button>
        </section>
      </main>
    );
  }
}
